export default function Footer() {
    return (
        <footer className="bg-transparent text-white text-center py-4">
            <div className="container mx-auto">
                <p className="text-sm">
                    © 2024 Nicholas Galupi. All rights reserved. | Built with ❤️ using React and Tailwind CSS | Backend built with Django
                </p>
            </div>
        </footer>
    );
};
